const PERMISSIONS_PREFIX = 'permissions';
export const MANAGEMENT_PERMISSIONS = `${PERMISSIONS_PREFIX}_dpms_management`;
export const SECURITY_MANAGEMENT_PERMISSIONS =
    `${PERMISSIONS_PREFIX}_dpms_security_management`;
export const PASSWORD_CHANGE_REQUIRED = 'passwordChangeRequired';

export default {
  MANAGEMENT_PERMISSIONS,
  SECURITY_MANAGEMENT_PERMISSIONS,
  PASSWORD_CHANGE_REQUIRED,
};
